module.exports = __webpack_public_path__ + "common/tp-featured7-07ed8444e122dd3cf17a616f5578f99d.svg";